module.exports = __webpack_public_path__ + "img/Img6.df1a906b.jpg";